import { CEHelloAttributesBase } from './ce-hello-attributes-base'


export class CEHelloAttributes extends CEHelloAttributesBase {

}